/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_meta_keywords = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juslin Komenan, portfolio développeur, software engineer, développeur full stack, backend engineer, architecte logiciel, développeur web, TypeScript developer, Node.js developer, Deno developer, SvelteKit developer, API sécurisée, authentification JWT, microservices, clean architecture, cloud computing, DevOps, scalabilité, performance web, SaaS, innovation numérique, développeur Côte d’Ivoire, développeur Abidjan, software engineer Africa`)
};

const en_meta_keywords = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juslin Komenan, developer portfolio, software engineer, full stack developer, backend engineer, software architect, web developer, TypeScript developer, Node.js developer, Deno developer, SvelteKit developer, secure API, JWT authentication, microservices, clean architecture, cloud computing, DevOps, scalability, web performance, SaaS, digital innovation, developer Ivory Coast, developer Abidjan, software engineer Africa`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const meta_keywords = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.meta_keywords(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("meta_keywords", locale)
	if (locale === "fr") return fr_meta_keywords(inputs)
	return en_meta_keywords(inputs)
};